module.exports = __webpack_public_path__ + "static/media/transpExmpl.7f836a54.jpg";